import {ProductFormReader} from '../vendor/theme-scripts/theme-product-form';

import SelloutVariants from './product-form-sellout';

const selectors = {
  product: '[data-product]',
  productForm: '[data-product-form]',
  productNotification: 'product-notification',
  variantTitle: '[data-variant-title]',
  notificationProduct: '[data-notification-product]',
  addToCart: '[data-add-to-cart]',
  addToCartText: '[data-add-to-cart-text]',
  cartPage: '[data-cart-page]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  finalSaleBadge: '[data-final-sale-badge]',
  formWrapper: '[data-form-wrapper]',
  originalSelectorId: '[data-product-select]',
  priceWrapper: '[data-price-wrapper]',
  productImages: 'product-images',
  productImage: '[data-product-image]',
  productMediaList: '[data-product-media-list]',
  productJson: '[data-product-json]',
  productPrice: '[data-product-price]',
  productSellingPrice: '[data-product-selling-price]',
  unitPrice: '[data-product-unit-price]',
  unitBase: '[data-product-base]',
  unitWrapper: '[data-product-unit]',
  isPreOrder: '[data-product-preorder]',
  productSlide: '.product__slide',
  subPrices: '[data-subscription-watch-price]',
  subSelectors: '[data-subscription-selectors]',
  subsToggle: '[data-toggles-group]',
  subsChild: 'data-group-toggle',
  subDescription: '[data-plan-description]',
  section: '[data-section-type]',
  variantSku: '[data-variant-sku]',
  variantFinalSaleMeta: '[data-variant-final-sale-metafield]',
  variantButtons: '[data-variant-buttons]',
  variantOptionImage: '[data-variant-option-image]',
  quickAddModal: '[data-quick-add-modal]',
  priceOffAmount: '[data-price-off-amount]',
  priceOffBadge: '[data-price-off-badge]',
  priceOffType: '[data-price-off-type]',
  priceOffWrap: '[data-price-off]',
  remainingCount: '[data-remaining-count]',
  remainingMax: '[data-remaining-max]',
  remainingWrapper: '[data-remaining-wrapper]',
  remainingJSON: '[data-product-remaining-json]',
  optionValue: '[data-option-value]',
  optionPosition: '[data-option-position]',
  installment: '[data-product-form-installment]',
  inputId: 'input[name="id"]',
};

const classes = {
  hidden: 'hidden',
  variantSoldOut: 'variant--soldout',
  variantUnavailable: 'variant--unavailable',
  productPriceSale: 'product__price--sale',
  remainingLow: 'count-is-low',
  remainingIn: 'count-is-in',
  remainingOut: 'count-is-out',
  remainingUnavailable: 'count-is-unavailable',
};

const attributes = {
  remainingMaxAttr: 'data-remaining-max',
  enableHistoryState: 'data-enable-history-state',
  notificationPopup: 'data-notification-popup',
  faderDesktop: 'data-fader-desktop',
  faderMobile: 'data-fader-mobile',
  optionPosition: 'data-option-position',
  imageId: 'data-image-id',
  mediaId: 'data-media-id',
  quickAddButton: 'data-quick-add-btn',
  finalSale: 'data-final-sale',
  variantImageScroll: 'data-variant-image-scroll',
};

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.isModalJustOpened = true;
  }

  connectedCallback() {
    this.cartAddEvents();

    this.container = this.closest(selectors.section) || this.closest(selectors.quickAddModal);
    if (!this.container) return;

    this.sectionId = this.container.dataset.sectionId;
    this.product = this.container.querySelector(selectors.product);
    this.productForm = this.container.querySelector(selectors.productForm);
    this.productNotification = this.container.querySelector(selectors.productNotification);
    this.productImages = this.container.querySelector(selectors.productImages);
    this.productMediaList = this.container.querySelector(selectors.productMediaList);
    this.installmentForm = this.container.querySelector(selectors.installment);
    this.skuWrapper = this.container.querySelector(selectors.variantSku);
    this.sellout = null;
    this.variantImageScroll = this.container.getAttribute(attributes.variantImageScroll) === 'true';

    this.priceOffWrap = this.container.querySelector(selectors.priceOffWrap);
    this.priceOffAmount = this.container.querySelector(selectors.priceOffAmount);
    this.priceOffType = this.container.querySelector(selectors.priceOffType);
    this.planDescription = this.container.querySelector(selectors.subDescription);
    this.popupBtn = document.querySelector('.product-variant-popup__button');

    this.remainingWrapper = this.container.querySelector(selectors.remainingWrapper);

    if (this.remainingWrapper) {
      const remainingMaxWrap = this.container.querySelector(selectors.remainingMax);
      if (remainingMaxWrap) {
        this.remainingMaxInt = parseInt(remainingMaxWrap.getAttribute(attributes.remainingMaxAttr), 10);
        this.remainingCount = this.container.querySelector(selectors.remainingCount);
        this.remainingJSONWrapper = this.container.querySelector(selectors.remainingJSON);
        this.remainingJSON = null;

        if (this.remainingJSONWrapper && this.remainingJSONWrapper.innerHTML !== '') {
          this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML);
        } else {
          console.warn('Missing product quantity JSON');
        }
      }
    }

    this.enableHistoryState = this.container.getAttribute(attributes.enableHistoryState) === 'true';
    this.hasUnitPricing = this.container.querySelector(selectors.unitWrapper);
    this.subSelectors = this.container.querySelector(selectors.subSelectors);
    this.subPrices = this.container.querySelector(selectors.subPrices);
    this.isPreOrder = this.container.querySelector(selectors.isPreOrder);
    this.firstLoad = false;

    let productJSON = null;
    const productElemJSON = this.container.querySelector(selectors.productJson);
    if (productElemJSON) {
      productJSON = productElemJSON.innerHTML;
    }
    if (productJSON) {
      this.productJSON = JSON.parse(productJSON);
      this.linkForm();
      this.sellout = new SelloutVariants(this.container, this.productJSON);
    } else {
      console.error('Missing product JSON');
    }

    this.variantOptionImages = this.container.querySelectorAll(selectors.variantOptionImage);
    this.variantButtons = this.container.querySelectorAll(selectors.variantButtons);
    if (this.variantOptionImages.length > 1) {
      this.optionImagesWidth();
    }

    if (this.closest('.product-quick-add')) {

    } else {
      this.updateTotalDiaperQty();
    }
  }

  cartAddEvents() {
    this.buttonATC = this.querySelector(selectors.addToCart);

    this.buttonATC.addEventListener('click', (e) => {
      e.preventDefault();

      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          detail: {
            button: this.buttonATC,
          },
          bubbles: false,
        })
      );

      if (!this.closest(selectors.quickAddModal)) {
        window.theme.a11y.lastElement = this.buttonATC;
      }
    });
  }

  destroy() {
    this.productForm.destroy();
  }

  linkForm() {
    //if (this.closest('.product-quick-add')) return;
    this.productForm = new ProductFormReader(this.container, this.productJSON, {
      onOptionChange: this.onOptionChange.bind(this),
      onPlanChange: this.onPlanChange.bind(this),
    });
    if (this.productJSON.variants.length === 1 || this.closest('.product-quick-add')) {
      this.pushState(this.productForm.getFormState(), true);
    }

    this.checkUrlParams()

    this.subsToggleListeners();
  }

  onOptionChange(evt) {
    this.pushState(evt.dataset);
  }

  onPlanChange(evt) {
    if (this.subPrices) {
      this.pushState(evt.dataset);
    }
  }

  pushState(formState, init = false) {
    this.productState = this.setProductState(formState);
    this.updateAddToCartState(formState);
    this.updateNotificationForm(formState);
    this.updateCartProductPrices(formState);
    this.updateGiftDetais(formState);
    this.updateProductPrices(formState);
    this.updateProductAddSubsPrices(formState);
    this.updateTotalDiaperQty(formState);
    this.updateProductImage(formState);
    this.updateSaleText(formState);
    this.updateSku(formState);
    this.updateRemaining(formState);
    this.updateLegend(formState);
    this.fireHookEvent(formState);
    this.updateNotifyForm(formState);
    this.sellout?.update(formState);
    this.updateSubsProps(formState)

    if (this.enableHistoryState && !init) {
      this.updateHistoryState(formState);
    }

    if (this.popupBtn) this.popupBtn.classList.remove('active');
    if (this.hasAttribute('data-main-product')) {
      document.querySelector('.product__subs__wrap')?.classList.remove('visually-hidden');
      document.querySelector('.product__additional-info')?.classList.remove('visually-hidden');
      document.querySelector('.product__additional-info')?.classList.add('updated-top-margin');
    }
  }

  checkUrlParams() {
    if (this.closest('.product-quick-add')) return;
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    const variantInput = document.querySelector(`[data-variant-id="current_id_${variantId}"]`);
    const variantItem = document.querySelector(`[data-variant-popup-id="current_id_${variantId}"]`);
    const additionalInfoWrapper = document.querySelector('.product__additional-info');

    if (variantItem) {
      variantItem.classList.add('active');
      const variantTitle = variantItem.getAttribute('data-variant-title');
      const variantText = variantItem.getAttribute('data-variant-text');
      if (variantTitle) document.querySelector('.product-variant-popup__button-title').innerHTML = variantTitle;
      if (variantText) document.querySelector('.product-variant-popup__button-text').innerHTML = variantText;

      setTimeout(() => {
        this.popupBtn.classList.add('active');
      }, 1000);
    }

    if(variantInput) {
      document.querySelector('.product__subs__wrap')?.classList.remove('visually-hidden');
      variantInput.checked = true;
      variantInput.click();
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      additionalInfoWrapper.classList.remove('visually-hidden');
      additionalInfoWrapper.classList.add('updated-top-margin');
    }
  }

  updateNotifyForm(formState) {
    const variant = formState.variant;
    const notifyFormVariantInput = document.querySelector('.product__notification input[name="variant"]');
    if (notifyFormVariantInput) notifyFormVariantInput.value = variant.id
  }

  updateAddToCartState(formState) {
    const variant = formState.variant;
    let addText = theme.strings.addToCart;
    const priceWrapper = this.container.querySelectorAll(selectors.priceWrapper);
    const addToCart = this.container.querySelectorAll(selectors.addToCart);
    const addToCartText = this.container.querySelectorAll(selectors.addToCartText);
    const formWrapper = this.container.querySelectorAll(selectors.formWrapper);
    const selectorsArray = document.querySelectorAll('.selector-wrapper');

    const getButtonText = (variant, defaultText, strings) => {
      if (!variant) return strings.unavailable;
      return variant.available ? defaultText : strings.soldOut;
    };

    const isButtonDisabled = (variant) => {
      return !variant || !variant.available;
    };


    if (this.installmentForm && variant) {
      const installmentInput = this.installmentForm.querySelector(selectors.inputId);
      installmentInput.value = variant.id;
      installmentInput.dispatchEvent(new Event('change', {bubbles: true}));
    }

    if (this.isPreOrder) {
      addText = theme.strings.preOrder;
    }

    if (this.closest('.product-quick-add')) {
      const popup = this.closest('.product-quick-add');
      const dataHideVariantPrice = popup.getAttribute('data-hide-variant-price');

      if (dataHideVariantPrice === 'false') {
        addText = theme.strings.updateBag;
      }
    }

    if (priceWrapper.length && variant) {
      priceWrapper.forEach((element) => {
        element.classList.remove(classes.hidden);
      });
    }

    if (selectorsArray.length > 1 && !this.closest('.product-quick-add')) {
      const variantSelected = document.querySelectorAll('[data-single-option-selector]:checked');
      if (variantSelected.length == 1) {
        const variantWrapped = variantSelected[0].closest('.selector-wrapper')
        selectorsArray.forEach((element) => {
          if (element !== variantWrapped) {
            const elementOptionName = element.getAttribute('data-option-name');
            addToCartText?.forEach((element) => {
              element.textContent = `Select ${elementOptionName}`;
            });
          }
        })
      } else {
        addToCart?.forEach(button => {
          if (button.hasAttribute(attributes.quickAddButton)) return;
          button.disabled = isButtonDisabled(variant);
        });

        addToCartText?.forEach(element => {
          element.textContent = getButtonText(variant, addText, theme.strings);
        });
      }
    } else {
      addToCart?.forEach(button => {
        if (button.hasAttribute(attributes.quickAddButton)) return;
        button.disabled = isButtonDisabled(variant);
      });

// Update text elements
      addToCartText?.forEach(element => {
        if (variant.title != 'Default Title') {
          element.textContent = getButtonText(variant, addText, theme.strings) + ` - ${variant.title}`;
        } else {
          element.textContent = getButtonText(variant, addText, theme.strings);
        }
      });

    }

    if (formWrapper.length) {
      formWrapper.forEach((element) => {
        if (variant) {
          if (variant.available) {
            element.classList.remove(classes.variantSoldOut, classes.variantUnavailable);
          } else {
            element.classList.add(classes.variantSoldOut);
            element.classList.remove(classes.variantUnavailable);
          }

          const formSelect = element.querySelector(selectors.originalSelectorId);
          if (formSelect) {
            formSelect.value = variant.id;
          }

          const inputId = element.querySelector(`${selectors.inputId}[form]`);
          if (inputId) {
            inputId.value = variant.id;
            inputId.dispatchEvent(new Event('change'));
          }
        } else {
          element.classList.add(classes.variantUnavailable);
          element.classList.remove(classes.variantSoldOut);
        }
      });
    }
  }


  updateNotificationForm(formState) {
    if (!this.productNotification || !formState?.variant) return;

    const variantTitle = this.productNotification.querySelector(selectors.variantTitle);
    const notificationProduct = this.productNotification.querySelector(selectors.notificationProduct);
    if (variantTitle != null && notificationProduct != null) {
      variantTitle.textContent = formState.variant.title;
      notificationProduct.value = formState.variant.name;
    }
  }

  updateHistoryState(formState) {
    if (this.closest('.product-quick-add')) return;
    const variant = formState.variant;
    const plan = formState.plan;
    const location = window.location.href;
    if (variant && location.includes('/product')) {
      const url = new window.URL(location);
      const params = url.searchParams;
      params.set('variant', variant.id);
      if (plan && plan.detail && plan.detail.id && this.productState.hasPlan) {
        params.set('selling_plan', plan.detail.id);
      } else {
        params.delete('selling_plan');
      }
      url.search = params.toString();
      const urlString = url.toString();
      window.history.replaceState({path: urlString}, '', urlString);
    }
  }

  updateRemaining(formState) {
    const variant = formState.variant;

    this.remainingWrapper?.classList.remove(classes.remainingIn, classes.remainingOut, classes.remainingUnavailable, classes.remainingLow);

    if (variant && this.remainingWrapper && this.remainingJSON) {
      const remaining = this.remainingJSON[variant.id];

      if (remaining === 'out' || remaining < 1) {
        this.remainingWrapper.classList.add(classes.remainingOut);
      }

      if (remaining === 'in' || remaining >= this.remainingMaxInt) {
        this.remainingWrapper.classList.add(classes.remainingIn);
      }

      if (remaining === 'low' || (remaining > 0 && remaining < this.remainingMaxInt)) {
        this.remainingWrapper.classList.add(classes.remainingLow);

        if (this.remainingCount) {
          this.remainingCount.innerHTML = remaining;
        }
      }
    } else if (!variant && this.remainingWrapper) {
      this.remainingWrapper.classList.add(classes.remainingUnavailable);
    }
  }

  optionImagesWidth() {
    if (this.closest('.product-quick-add')) return;
    if (!this.variantButtons) return;

    let maxItemWidth = 0;

    requestAnimationFrame(() => {
      this.variantOptionImages.forEach((item) => {
        const itemWidth = item.clientWidth;
        if (itemWidth > maxItemWidth) {
          maxItemWidth = itemWidth;
        }
      });

      this.variantButtons.forEach((item) => {
        item.style?.setProperty('--option-image-width', maxItemWidth + 'px');
      });
    });
  }

  getBaseUnit(variant) {
    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
  }

  subsToggleListeners() {
    const toggles = this.container.querySelectorAll(selectors.subsToggle);
    const groups = this.container.querySelectorAll('.product__subs__group');
    const productFormSubInput = document.querySelector('.product__form-sub__plan');
    const productFormSubPropsPrice = document.querySelector('.product__form-sub__props-price');
    const productFormSubPropsDiscount = document.querySelector('.product__form-sub__props-discount');

    toggles.forEach((toggle) => {
      toggle.addEventListener(
        'change',
        function (e) {
          const target = e.target;
          const targetWrapper = target.closest('.product__subs__group');
          const addTargetVariantID = targetWrapper.getAttribute('data-add-variant');
          const addTargetVariantPlan = targetWrapper.getAttribute('data-variant-plan');
          const addTargetVariantPrice = targetWrapper.getAttribute('data-original-price');
          const addTargetVariantSubsDiscount = targetWrapper.getAttribute('data-subs-discount');
          const mainProductForm = document.querySelector('[data-product-form]');
          const additionalSubWrapper = document.getElementById('AdditionalSubscriptionsWrapper');
          const mainPriceWrappers = document.querySelector('[data-main-product-price]');
          groups.forEach((group) => group.classList.remove('active'));
          targetWrapper.classList.add('active');
          const selectedSub = target.value;
          if (selectedSub) {
            if (productFormSubInput) productFormSubInput.value = selectedSub;
            productFormSubPropsPrice?.removeAttribute('disabled');
            productFormSubPropsDiscount?.removeAttribute('disabled');
          } else {
            if (productFormSubInput) productFormSubInput.value = '';
            productFormSubPropsPrice?.setAttribute('disabled', '');
            productFormSubPropsDiscount?.setAttribute('disabled', '');
          }

          if (target.getAttribute('id') === 'one-time-purchase--input' && mainPriceWrappers) {
            document.querySelector('[data-main-product-price]').innerHTML = document.querySelector('[data-price-onetime]')?.innerHTML;
          } else if (mainPriceWrappers){
            document.querySelector('[data-main-product-price]').innerHTML = document.querySelector('[data-price-subscription]')?.innerHTML || document.querySelector('[data-price-onetime]')?.innerHTML;
          }

          if (addTargetVariantID) {
            let innerOfWrapper = `
                <input type="hidden" id="AdditionalSubscriptionsVariantId" name="items[1][id]" value="${addTargetVariantID}">
                <input type="hidden" name="items[1][quantity]" value="1">
              `;

            if (addTargetVariantPlan) {
              innerOfWrapper = `
                <input type="hidden" id="AdditionalSubscriptionsVariantId" name="items[1][id]" value="${addTargetVariantID}">
                <input type="hidden" name="items[1][quantity]" value="1">
                <input type="hidden" id="AdditionalSubscriptionsVariantPlan" name="items[1][selling_plan]" value="${addTargetVariantPlan}">
                <input type="hidden" name="items[1][properties][_subscription_original_price]" value="${addTargetVariantPrice}">
                <input type="hidden" name="items[1][properties][_subscription_discount]" value="${addTargetVariantSubsDiscount}">
              `;
            }


            if (additionalSubWrapper) {
              additionalSubWrapper.innerHTML = innerOfWrapper;
            } else {
              const wrapper = document.createElement('div');
              wrapper.id = 'AdditionalSubscriptionsWrapper';
              wrapper.classList.add('product__form-sub__wrapper');
              wrapper.innerHTML = innerOfWrapper;
              mainProductForm.appendChild(wrapper);
            }
          } else if (additionalSubWrapper) {
            additionalSubWrapper.remove();
          }
        }.bind(this)
      );
    });
  }

  updateSaleText(formState) {
    if (!this.priceOffWrap) return;

    if (this.productState.planSale) {
      this.updateSaleTextSubscription(formState);
    } else if (this.productState.onSale) {
      this.updateSaleTextStandard(formState);
    } else {
      this.priceOffWrap.classList.add(classes.hidden);
    }
  }

  isVariantFinalSale(variant) {
    const metafieldsData = document.querySelector(selectors.variantFinalSaleMeta)?.textContent;
    if (!metafieldsData) return;

    const variantsMetafields = JSON.parse(metafieldsData);
    let variantIsFinalSale = false;

    variantsMetafields.forEach((variantMetafield) => {
      if (Number(variantMetafield.variant_id) === variant.id) {
        variantIsFinalSale = variantMetafield.metafield_value === 'true';
      }
    });

    return variantIsFinalSale;
  }

  updateSaleTextStandard(formState) {
    if (this.closest('.product-quick-add')) return;
    const variant = formState.variant;
    const finalSaleBadge = this.priceOffWrap?.querySelector(selectors.finalSaleBadge);
    const priceOffBadge = this.priceOffWrap?.querySelector(selectors.priceOffBadge);
    const comparePrice = variant?.compare_at_price;
    const salePrice = variant?.price;

    // Set sale type text if element exists
    if (this.priceOffType) {
      this.priceOffType.innerHTML = window.theme.strings.sale || 'sale';
    }

    // If priceOffBadge or priceOffAmount are missing, hide priceOffBadge and exit early
    if (!priceOffBadge || !this.priceOffAmount || !comparePrice || comparePrice <= salePrice) {
      priceOffBadge?.classList.add(classes.hidden);
    } else {
      // Calculate and display discount percentage
      const discountInt = Math.round(((comparePrice - salePrice) / comparePrice) * 100);
      this.priceOffAmount.innerHTML = `${discountInt}%`;
      priceOffBadge.classList.remove(classes.hidden);
    }

    // Display or hide the final sale badge
    const isFinalSale = this.priceOffWrap?.hasAttribute(attributes.finalSale) || this.isVariantFinalSale(variant);
    if (finalSaleBadge) {
      finalSaleBadge.classList.toggle(classes.hidden, !isFinalSale);
    }

    this.priceOffWrap.classList.remove(classes.hidden);
  }

  updateSaleTextSubscription(formState) {
    if (this.closest('.product-quick-add')) return;
    if (this.priceOffType) {
      this.priceOffType.innerHTML = window.theme.strings.subscription || 'subscripton';
    }

    if (this.priceOffAmount && this.priceOffWrap) {
      const adjustment = formState.plan.detail.price_adjustments[0];
      const discount = adjustment.value;
      if (adjustment && adjustment.value_type === 'percentage') {
        this.priceOffAmount.innerHTML = `${discount}%`;
      } else {
        this.priceOffAmount.innerHTML = window.theme.formatMoney(discount, theme.moneyFormat);
      }
      this.priceOffWrap.classList.remove(classes.hidden);
    }
  }

  updateProductAddSubsPrices(formState){
    if (this.closest('.product-quick-add')) return;
    const variant = formState.variant;
    const plan = variant.selling_plan_allocations[0];
    const addPriceWrappers = this.container.querySelectorAll('[data-add-price-wrapper]');


    addPriceWrappers?.forEach((wrap) => {
      const comparePriceEl = wrap.querySelector('[data-add-price-compare-wrapper]');
      const productPriceEl = wrap.querySelector('[data-add-price-original-wrapper]');
      const addVariantPrice = wrap.getAttribute('data-add-variant-price');
      const addVariantComparePrice = wrap.getAttribute('data-add-variant-compare-price');

      let comparePrice = '';
      let price = '';

      if (wrap.hasAttribute('data-add-otp-variant-price')) {
        price = variant.price + Number(addVariantPrice);
      }

      if (plan) {
        comparePrice = variant.price + Number(addVariantComparePrice);
        price = plan.price + Number(addVariantPrice);
      }

      if (comparePriceEl) {
        comparePriceEl.innerHTML = window.theme.formatMoney(comparePrice, theme.moneyFormat);
      }

      productPriceEl.innerHTML = price === 0 ? window.theme.strings.free : window.theme.formatMoney(price, theme.moneyFormat);
    })
  }

  updateTotalDiaperQty(formState) {
    if (this.closest('.product-quick-add')) return;
    // Update total diapers quantity
    const totalQuantityElems = document.querySelectorAll('.product__subs__wrap .total-quantity');
    const totalPackNumberElems = document.querySelectorAll('.product__subs__wrap .total-pack-number');
    const variantSelected = document.querySelector('.product__content [data-single-option-selector]:checked') || document.querySelector('.product__content [data-single-option-selector]');

    if (totalQuantityElems.length > 0 && variantSelected?.getAttribute('data-total-packs-qnt')) {
      totalQuantityElems.forEach((elem) => {
        elem.innerHTML = variantSelected.getAttribute('data-total-packs-qnt');
      })
    }

    if (totalPackNumberElems.length > 0 && variantSelected?.getAttribute('data-total-pack-number')) {
      totalPackNumberElems.forEach((elem) => {
        elem.innerHTML = variantSelected.getAttribute('data-total-pack-number');
      })
    }
  }

  updateCartProductPrices(formState) {
    if (!this.closest('.product-quick-add')) return;

    let variant = formState.variant;
    const hideVariantPrice = this.container.getAttribute('data-hide-variant-price');
    const variantPriceWrapper = this.container?.querySelector('.product-quick-add__upsell-product-price .product__price__wrap');
    const startedPrice = this.container?.querySelector('.product-quick-add__upsell-product-price .started-price');
    let variantInputs;

    if (this.isModalJustOpened && hideVariantPrice === 'false') {
      const dataVariant = this.container.getAttribute('data-variant');
      const selectedVariant = JSON.parse(dataVariant);
      variantInputs = this.container.querySelectorAll('.radio__button');

      variant = selectedVariant;

      const variantOption1 = variant.option1;
      const variantOption2 = variant.option2;
      const variantOption3 = variant.option3;

      variantInputs.forEach((span) => {
        const input = span.querySelector('input');
        const label = span.querySelector('label');
        const inputValue = input.value;

        if (inputValue === variantOption1) {
          label.click();
        }

        if (variantOption2 !== null && inputValue === variantOption2) {
          label.click();
        }

        if (variantOption3 !== null && inputValue === variantOption3) {
          label.click();
        }
      });


      startedPrice.style.display = 'none';
      variantPriceWrapper.style.display = 'flex';
      this.isModalJustOpened = false;
    }

    if (hideVariantPrice === 'true') {
      startedPrice.style.display = 'none';
      variantPriceWrapper.style.display = 'flex';
    }

    const plan = formState.plan;
    const priceWrappers = this.container.querySelectorAll(selectors.priceWrapper);
    let sellingPlanPrice = '';
    if (variant.selling_plan_allocations) {
      sellingPlanPrice = variant?.selling_plan_allocations[0]?.price_adjustments[0]?.price;
    }

    priceWrappers.forEach((wrap) => {
      const comparePriceEl = wrap.querySelector(selectors.comparePrice);
      const productPriceEl = wrap.querySelector(selectors.productPrice);
      const productSellingPriceEl = wrap.querySelector(selectors.productSellingPrice);
      const comparePriceText = wrap.querySelector(selectors.comparePriceText);

      let comparePrice = '';
      let price = '';

      if (variant.available) {
        comparePrice = variant.compare_at_price;
        price = variant.price;
      }

      if (this.productState.hasPlan) {
        price = variant?.selling_plan_allocations[0]?.price_adjustments[0]?.price;
      }

      if (this.productState.planSale) {
        comparePrice = plan.allocation.compare_at_price;
        price = variant?.selling_plan_allocations[0]?.price_adjustments[0]?.price;
      }

      if (comparePriceEl) {
        if (this.productState.onSale || this.productState.planSale) {
          comparePriceEl.classList.remove(classes.hidden);
          comparePriceText.classList.remove(classes.hidden);
          productPriceEl.classList.add(classes.productPriceSale);
        } else {
          comparePriceEl.classList.add(classes.hidden);
          comparePriceText.classList.add(classes.hidden);
          productPriceEl.classList.remove(classes.productPriceSale);
        }
        comparePriceEl.innerHTML = window.theme.formatMoney(comparePrice, theme.moneyFormat);
        comparePriceEl.setAttribute('data-price-strike', window.theme.formatMoney(comparePrice, theme.moneyFormat));
      }

      if (sellingPlanPrice !== price && sellingPlanPrice !== '' && typeof sellingPlanPrice !== 'undefined') {
        productSellingPriceEl.innerHTML = price === 0 ? window.theme.strings.free : window.theme.formatMoney(sellingPlanPrice, theme.moneyFormat);
        productSellingPriceEl.setAttribute('data-selling-price', window.theme.formatMoney(sellingPlanPrice, theme.moneyFormat));
        productPriceEl.innerHTML = price === 0 ? window.theme.strings.free : window.theme.formatMoney(price, theme.moneyFormat);
        productPriceEl.setAttribute('data-prod-price', window.theme.formatMoney(price, theme.moneyFormat));
      } else if (sellingPlanPrice !== '' && typeof sellingPlanPrice !== 'undefined') {
        productPriceEl.innerHTML = price === 0 ? window.theme.strings.free : window.theme.formatMoney(sellingPlanPrice, theme.moneyFormat);
      } else {
        productPriceEl.innerHTML = price === 0 ? window.theme.strings.free : window.theme.formatMoney(price, theme.moneyFormat);
        productPriceEl.setAttribute('data-price-sale', window.theme.formatMoney(price, theme.moneyFormat));
      }
    });

    const qtyCounter = this.container.querySelector('quantity-counter');
    let qtyValue = this.container.getAttribute('data-line-qty');
    if (qtyValue === '') {
      qtyValue = 1;
    }
    qtyCounter.updateAllPrices(this.container, qtyValue);

    if (this.hasUnitPricing) {
      this.updateProductUnits(formState);
    }
  }

  updateProductPrices(formState) {
    if (this.closest('.product-quick-add')) return;

    const variant = formState.variant;
    const plan = variant.selling_plan_allocations[0];
    const priceWrappers = this.container.querySelectorAll(selectors.priceWrapper);

    priceWrappers.forEach((wrap) => {
      const comparePriceEl = wrap.querySelector(selectors.comparePrice);
      const productPriceEl = wrap.querySelector(selectors.productPrice);

      let comparePrice = '';
      let price = '';
      let comparePriceVariant = ''

      if (this.productState.available) {
        comparePriceVariant = variant.compare_at_price;
        price = variant.price;
      }

      if (plan) {
        price = plan.price;
        comparePrice = variant.price;
      }

      if (comparePriceEl && !wrap.hasAttribute('data-price-onetime')) {
        if (this.productState.onSale || plan) {
          comparePriceEl.classList.remove(classes.hidden);
          productPriceEl.classList.add(classes.productPriceSale);
        } else {
          comparePriceEl.classList.add(classes.hidden);
          productPriceEl.classList.remove(classes.productPriceSale);
        }
        if (comparePrice) {
          comparePriceEl.innerHTML = window.theme.formatMoney(comparePrice, theme.moneyFormat);
        } else if (comparePriceVariant) {
          comparePriceEl.innerHTML = window.theme.formatMoney(comparePriceVariant, theme.moneyFormat);
        }
      } else if (comparePrice && wrap.hasAttribute('data-main-product-price')) {
        const span = document.createElement('span');
        span.className = 'product__price--compare product__price--strike';
        span.setAttribute('data-compare-price', '');
        span.innerHTML = window.theme.formatMoney(comparePrice, theme.moneyFormat);
        wrap.prepend(span);
        productPriceEl.classList.add(classes.productPriceSale);
      }  else if (comparePriceVariant && wrap.hasAttribute('data-price-onetime')) {
        if (comparePriceVariant === comparePrice) {
          comparePriceEl.classList.add(classes.hidden);
          productPriceEl.classList.remove(classes.productPriceSale);
        } else {
          comparePriceEl.classList.remove(classes.hidden);
          productPriceEl.classList.add(classes.productPriceSale);
        }
        comparePriceEl.innerHTML = window.theme.formatMoney(comparePriceVariant, theme.moneyFormat);
      }

      if (wrap.hasAttribute('data-price-onetime')) {
        productPriceEl.innerHTML = variant.price === 0 ? window.theme.strings.free : window.theme.formatMoney(variant.price, theme.moneyFormat);
      } else {
        productPriceEl.innerHTML = price === 0 ? window.theme.strings.free : window.theme.formatMoney(price, theme.moneyFormat);
      }

      if (!this.querySelector('.product__form-sub__plan')?.value) {
        const onetimeValue = document.querySelector('[data-price-onetime]')?.innerHTML;
        if (onetimeValue)  document.querySelector('[data-main-product-price]').innerHTML = onetimeValue;
      } else {
        const priceSubscription = document.querySelector('[data-price-subscription]')?.innerHTML;
        if (priceSubscription) document.querySelector('[data-main-product-price]').innerHTML = priceSubscription;
      }
    });

    if (this.hasUnitPricing) {
      this.updateProductUnits(formState);
    }
  }

  updateProductUnits(formState) {
    const variant = formState.variant;
    const plan = formState.plan;
    let unitPrice = null;

    if (variant && variant.unit_price) {
      unitPrice = variant.unit_price;
    }
    if (plan && plan.allocation && plan.allocation.unit_price) {
      unitPrice = plan.allocation.unit_price;
    }

    if (unitPrice) {
      const base = this.getBaseUnit(variant);
      const formattedPrice = window.theme.formatMoney(unitPrice, theme.moneyFormat);
      this.container.querySelector(selectors.unitPrice).innerHTML = formattedPrice;
      this.container.querySelector(selectors.unitBase).innerHTML = base;
      this.container.querySelector(selectors.unitWrapper).classList.remove(classes.hidden);
    } else {
      this.container.querySelector(selectors.unitWrapper).classList.add(classes.hidden);
    }
  }

  updateSku(formState) {
    if (!this.skuWrapper) return;

    this.skuWrapper.innerHTML = `${theme.strings.sku}: ${formState.variant.sku}`;
  }

  fireHookEvent(formState) {
    const variant = formState.variant;
    const selected = formState.selected;
    this.container.dispatchEvent(new CustomEvent('theme:variant:change', {detail: {variant, selected}, bubbles: true}));
  }

  /**
   * Tracks aspects of the product state that are relevant to UI updates
   * @param {object} evt - variant change event
   * @return {object} productState - represents state of variant + plans
   *  productState.available - current variant and selling plan options result in valid offer
   *  productState.soldOut - variant is sold out
   *  productState.onSale - variant is on sale
   *  productState.showUnitPrice - variant has unit price
   *  productState.requiresPlan - all the product variants requires a selling plan
   *  productState.hasPlan - there is a valid selling plan
   *  productState.planSale - plan has a discount to show next to price
   *  productState.planPerDelivery - plan price does not equal per_delivery_price - a prepaid subscription
   */
  setProductState(dataset) {
    const variant = dataset.variant;
    const plan = dataset.plan;

    const productState = {
      available: true,
      soldOut: false,
      onSale: false,
      showUnitPrice: false,
      requiresPlan: false,
      hasPlan: false,
      planPerDelivery: false,
      planSale: false,
    };

    if (!variant || (variant.requires_selling_plan && !plan)) {
      productState.available = false;
    } else {
      if (!variant.available) {
        productState.soldOut = true;
      }

      if (variant.compare_at_price > variant.price) {
        productState.onSale = true;
      }

      if (variant.unit_price) {
        productState.showUnitPrice = true;
      }

      if (this.product && this.product.requires_selling_plan) {
        productState.requiresPlan = true;
      }

      if (plan && this.subPrices) {
        productState.hasPlan = true;
        if (plan.allocation.per_delivery_price !== plan.allocation.price) {
          productState.planPerDelivery = true;
        }
        if (variant.price > plan.allocation.price) {
          productState.planSale = true;
        }
      }
    }
    return productState;
  }

  updateProductImage(evt) {
    if (this.closest('.product-quick-add')) return;
    if (!this.hasAttribute('data-cart-recommendation')) return;
    const variant = evt.dataset?.variant || evt.variant;

    if (!variant) return;
    if (this.firstLoad === true) {
      fetch(`${window.location.pathname}?variant=${variant.id}`)
        .then(response => response.text())
        .then(data => {
          const html = new DOMParser().parseFromString(data, 'text/html');
          const newMedia = html.querySelector(`[data-product-media-list]`);
          const oldMedia = document.querySelector(`[data-product-media-list]`);
          oldMedia.innerHTML = newMedia.innerHTML;

          const swipers = document.querySelector(`[data-product-media-list]`).querySelectorAll("swiper-container[init]");
          if (!swipers) return;
          swipers.forEach(swiper => {
            const dataParams = swiper.getAttribute("data-init-params");
            const swiperParams = JSON.parse(dataParams);

            if (swiper.initialized) {
              swiper.initialized = false;
            }

            Object.assign(swiper, swiperParams);
            swiper.initialize();
          });
        });
    }

    this.firstLoad = true;
  }

  updateLegend(formState) {
    const variant = formState.variant;
    if (variant) {
      const optionValues = this.container.querySelectorAll(selectors.optionValue);
      if (optionValues.length) {
        optionValues.forEach((optionValue) => {
          const selectorWrapper = optionValue.closest(selectors.optionPosition);
          if (selectorWrapper) {
            const optionPosition = selectorWrapper.getAttribute(attributes.optionPosition);
            const optionIndex = parseInt(optionPosition, 10) - 1;
            const selectedOptionValue = variant.options[optionIndex];
            optionValue.innerHTML = selectedOptionValue;
          }
        });
      }
    }
  }

  updateGiftDetais(formState) {
    const variant = formState.variant;
    const popupOpen = this.container.querySelector(`[data-gift-details-popup-open]`);

    if (variant) {
      popupOpen?.removeAttribute('disabled')
    } else {
      popupOpen?.setAttribute('disabled', true);
    }
  }

  updateSubsProps(formState) {
    if (!formState.variant) return

    const priceProp = this.container.querySelector('.product__form-sub__props-price');
    const discountProp = this.container.querySelector('.product__form-sub__props-discount');

    if (priceProp) {
      priceProp.value = window.theme.formatMoney(formState.variant.selling_plan_allocations[0].compare_at_price, theme.moneyFormat);
    }

    if (discountProp) {
      const discount = formState.variant.selling_plan_allocations[0].compare_at_price - formState.variant.selling_plan_allocations[0].price;
      discountProp.value = window.theme.formatMoney(discount, theme.moneyFormat);
    }
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}
